import {
  Directive,
  ElementRef,
  Injector,
  Renderer2,
} from '@angular/core';
import { PatternlibControlValueAccessorCommonBase } from './common-base';

/**
 * Base class for everything that writes to a 'value' property.
 */
@Directive()
export abstract class PatternlibControlValueAccessorValueBase extends PatternlibControlValueAccessorCommonBase {
  constructor(_renderer: Renderer2, _injector: Injector, _elementRef: ElementRef) {
    super(_renderer, _injector, _elementRef);
  }

  override writeValue(value: any) {
    this._renderer.setProperty(this._elementRef.nativeElement, 'value', value);
  }
}
